import React  from "react";
import { useParams } from 'react-router-dom';
import AccountForm from "./components/AccountForm";

const EditAccount = () => {
	const { accountId } = useParams();

	return (
	    <div>
	      <div className="mt-5 grid h-full grid-cols-1 gap-4">
      		<AccountForm recordId={accountId ?? 0} mode="edit"/>
	      </div>
	    </div>
    );
};

export default EditAccount;